module.exports = __webpack_public_path__ + "img/home-talk.a9854b87.png";